<script lang="ts">
    import { trans } from '$assets/shop-translator.js';
    import cn from '$common/utils/cn.js';
    import { formatCurrency } from '$saga/utils/price';
    import {
        selectedPrice,
        snowtrexPendingSelection,
        snowtrexSelectedPax,
    } from '$saga/views/Tour/store';
    import {
        getCheapestSnowtrexAccommodationPrice,
        getSnowtrexPriceForAside,
    } from '$saga/views/Tour/VisibleDates/SnowtrexVisibleDates/utils';
    import type { SnowtrexAccommodationDate } from '$saga/views/Tour/VisibleDates/types';

    export let originalPrice: number | null,
        rebateAmount: number | null,
        minPrice: number | null,
        isSnowtrex = false,
        snowtrexAccommodationDates: SnowtrexAccommodationDate[] = [],
        selectedDuration: number | null = null;

    $: snowtrexSelectedPrice = isSnowtrex
        ? ($snowtrexPendingSelection?.selectedPrice ??
          getCheapestSnowtrexAccommodationPrice(
              snowtrexAccommodationDates,
              $snowtrexSelectedPax,
              selectedDuration,
          ))
        : null;
    $: snowtrexPriceForAside = isSnowtrex
        ? getSnowtrexPriceForAside(
              snowtrexAccommodationDates,
              $snowtrexPendingSelection?.pax ?? $snowtrexSelectedPax,
              selectedDuration,
              snowtrexSelectedPrice,
          )
        : null;

    $: asidePrice = isSnowtrex
        ? {
              noDateSelected: $snowtrexPendingSelection === null,
              displayedPrice: snowtrexPriceForAside ?? minPrice ?? 0,
              displayedOriginalPrice:
                  snowtrexSelectedPrice?.originalPrice ?? null,
              displayedRebateAmount:
                  snowtrexSelectedPrice?.rebateAmount ?? null,
              hasRebate: snowtrexSelectedPrice?.rebateAmount != null,
          }
        : {
              noDateSelected: $selectedPrice.actualPrice == null,
              displayedPrice: $selectedPrice.actualPrice ?? minPrice ?? 0,
              displayedOriginalPrice:
                  $selectedPrice.originalPrice ?? originalPrice,
              displayedRebateAmount:
                  $selectedPrice.rebateAmount ?? rebateAmount,
              hasRebate:
                  $selectedPrice.rebateAmount != null ||
                  ($selectedPrice.actualPrice == null && rebateAmount != null),
          };
</script>

<div class="flex w-full flex-col desktop:gap-xs">
    <div class="flex flex-col gap-2xs desktop:gap-xs">
        {#if asidePrice.noDateSelected}
            <span
                class="w-full text-left text-xs text-content-quiet desktop:text-base"
            >
                {trans('tour.aside_panel.action.min_price')}
            </span>
        {/if}

        <div class="flex items-center gap-2xs">
            <div
                class={cn(
                    'w-fit bg-commercial-catchy p-2xs font-semibold desktop:text-2xl',
                    asidePrice.hasRebate && 'bg-status-negative text-white',
                )}
            >
                {formatCurrency(asidePrice.displayedPrice, false, 'EUR', true)}
            </div>
            <span class="text-xs font-normal desktop:text-base">
                {trans('tour.aside_panel.action.by_pers')}
            </span>
        </div>

        {#if asidePrice.hasRebate}
            <div class="flex gap-2xs">
                <div class="text-xs line-through desktop:text-sm">
                    {formatCurrency(
                        asidePrice.displayedOriginalPrice ?? 0,
                        false,
                        'EUR',
                        true,
                    )}
                </div>
                <div class="text-xs text-status-negative desktop:text-sm">
                    -{formatCurrency(
                        asidePrice.displayedRebateAmount ?? 0,
                        false,
                        'EUR',
                        true,
                    )}
                </div>
            </div>
        {/if}
    </div>
</div>
